<template>
	<div
		class="modal-title modal-title-sticky padding-bottom-xs-1"
		v-if="ui.calendarViewType == 'month'"
	>
		<div class="col-xs-12">
			<h3
				class="
					margin-bottom-xs-1
					padding-bottom-xs-1
					menu-item-lined
					no-line-top
					capitalize
				"
			>
				{{ activities.selected.activity_name }}
				<span class="modal-activity-date">
					{{ dates.active.monthName }} {{ year }}
				</span>
			</h3>
			<a
				href="#"
				class="modal-close link-close-right"
				@click.prevent="setModalState(0)"
			></a>
			<div class="modal-title-arrows">
				<div class="booking-calendar-month-mobile-header-navigation">
					<div class="previous-month">
						<a
							href="#"
							class="link-arrow-left capitalize"
							@click.prevent="setupActiveDates('back')"
							v-if="!dateIsInThePast"
							>{{ dates.active.previousMonthShortName }}</a
						>
					</div>
					<div class="current-month text-center">
						<span class="capitalize"
							><strong>{{
								dates.active.monthLongName
							}}</strong></span
						>
					</div>
					<div class="next-month text-align-right-xs">
						<a
							href="#"
							class="link-arrow-right capitalize"
							@click.prevent="setupActiveDates('forward')"
							>{{ dates.active.nextMonthShortName }}</a
						>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>



<script>
import { mapState, mapGetters, mapActions } from "vuex";
import ProviderAndCalendarNavMobile from "./ProviderAndCalendarNavMobile.vue";
import BookingCalendarMonth from "./BookingCalendarMonth.vue";
import BookingCalendarWeekMobile from "./BookingCalendarWeekMobile.vue";

export default {
	components: {
		ProviderAndCalendarNavMobile,
		BookingCalendarMonth,
		BookingCalendarWeekMobile,
	},
	computed: {
		...mapState([
			"activityGroups",
			"activities",
			"providers",
			"selectedSlot",
			"dates",
			"ui",
			"booking",
			"patient",
		]),
		...mapGetters([
			"dateIsInThePast",
			"activityIsCampaign",
			"formatProviderName",
			"selectedSlotFormated",
			"formIsValid",
			"noAvailableTimesForWeek",
		]),
		year() {
			if (this.dates.active.niceDate) {
				return this.dates.active.niceDate.substring(0, 4);
			}
			return this.dates.active.year;
		},
	},
	methods: {
		...mapActions([
			"setActivityGroup",
			"setActivity",
			"setupActiveDates",
			"setSelectedSlot",
			"setProvider",
			"getRealWeekday",
			"setModalState",
			"handleSwipe",
			"prepareNewBooking",
			"shouldDeselectTimeslot",
		]),
	},
};
</script>